import React from 'react'
import { Input } from 'reactstrap'

/**
 * 
 * @param {import('../types').FormV2FieldProps} param0 
 */
const TextV2Field = ({
    field,
    value,
    onChange,
    onBlur,
    onFocus,
    isRequired,
    isDisabled,
    errorMessage,
    classes,
    styles,
    placeholder,
    lang,
    aria,
    id,
    name,
    type,
    valid,
    hasError
}) => {
    return (
        <Input
            id={id}
            name={name}
            type={type === 'email' ? 'text' : type}
            placeholder={placeholder?.translate(lang)}
            value={value}
            onChange={e => onChange?.(e.target.value)}
            onBlur={onBlur}
            onFocus={onFocus}
            disabled={isDisabled}
            required={isRequired}
            invalid={hasError}
            valid={valid}
            {...aria || {}}
            className={`formV2-field-input-text ${type === 'date' ? 'formV2-field-input-text-date' : ''} ${classes?.field}`}
            style={styles?.field}
            rows={field.type === 'textarea' ? (field.config?.rows || 4) : undefined}
            autoComplete={field?.config?.autoComplete}
            inputMode={['number', 'date'].includes(type) ? 'numeric' : type === 'email' ? 'email' : undefined}
            min={type === 'date' && field?.config?.min ? field.config.min : undefined}
            max={type === 'date' && field?.config?.max ? field.config.max : undefined}
        />
    )
}

export default TextV2Field